module.exports = __webpack_public_path__ + "img/foot.dab4003b.png";